<img class="ie-white" src="/images/bg-white.png" /> <!--  ie hack image  -->
<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">USPVS Verification</h4>
</div>

<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <ng-container *ngIf="displayResults">
        <form [formGroup]="uspvsVerificationForm" autocomplete="off">
            <h2>Verification Lookup</h2>
            <fieldset>
                <div class="row">
                    <div class="col-sm-4 mvd_form-group">
                        <label>Customer Sequence Number</label>
                        <input class="mvd_form-control" type="text" formControlName="legacySequenceNumber" />
                    </div>
                    <div class="col-sm-3 mvd_form-group">
                        <label class="required" title="* Required">Passport Number</label>
                        <input class="mvd_form-control" type="text" formControlName="passportNumber" />
                        <div class="mvd_alert__validation">
                            <div class="mvd_alert__rule" *ngIf="uspvsVerificationForm.get('passportNumber').touched && uspvsVerificationForm.get('passportNumber').hasError('required')">Passport number is required</div>
                        </div>
                    </div>
                    <div class="col-sm-3 col-md-2 mvd_form-group">
                        <label class="required" title="* Required">Date of Birth</label>
                        <p-inputMask mask="99/99/9999" placeholder="mm/dd/yyyy" slotChar="mm/dd/yyyy" formControlName="dateOfBirth"></p-inputMask>
                        <div class="mvd_alert__validation">
                            <div class="mvd_alert__rule" *ngIf="uspvsVerificationForm.get('dateOfBirth').touched && uspvsVerificationForm.get('dateOfBirth').hasError('required')">Date of birth is required</div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </form>

        <h2>Validation Code</h2>
        <div class="row">
            <div class="col-sm-1">
                <div class="spinner" *ngIf="!displayResults || loadingUspvsMessage"></div>
                <div class="mvd_form-control" disabled *ngIf="showValidationCode && !loadingUspvsMessage">
                    {{data.validationCode}}
                </div>
            </div>
        </div>
    </ng-container>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" onClick="window.print()" *ngIf="showValidationCode && !loadingUspvsMessage">Print</button>
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <button class="btn--primary" type="submit" (click)="search()" [ngClass]="{loading: showButtonLoading}">Lookup</button>
    </div>    
</div>
